import { useState } from 'react';

const useDrawerManager = <T extends string>() => {
    const [open, setOpen] = useState<T | null>(null);

    const openDrawer = (action: T) => setOpen(action);
    const closeDrawer = () => setOpen(null);
    const isOpen = (action: T) => open === action;
    const isAnyOpen = open !== null;

    return { open, setOpen, openDrawer, closeDrawer, isOpen, isAnyOpen };
};

export default useDrawerManager;
